/**
 * When Results may show prize amounts.
 *
 * Lock Payouts on Finance does not publish money. Admin Preview Payouts
 * shows amounts to that admin. Lock Results publishes to everyone.
 * Unlock Results pulls public amounts back.
 */
export const shouldShowResultPrizes = ({
  isResultsFinalized = false,
  isPreviewingPayouts = false,
} = {}) => Boolean(isResultsFinalized || isPreviewingPayouts);

export const determinePayoutAccess = (
  verificationStatus = {},
  showPayouts = false,
  userPermissions = {}
) => {
  if (verificationStatus?.results?.isVerified) {
    return true;
  }
  return Boolean(userPermissions?.canManage && showPayouts);
};

export const stripResultPrizes = (results) => {
  if (!Array.isArray(results)) {
    return [];
  }
  return results.map((row) => {
    if (!row || typeof row !== "object") {
      return row;
    }
    const next = { ...row };
    delete next.prize;
    delete next.tieDescription;
    return next;
  });
};

/**
 * Public cache (includePayouts false) keeps places but not money until
 * Lock Results. Preview writes includePayouts true with amounts.
 */
export const payloadForResultsCache = (
  payload = {},
  includePayouts = false,
  resultsLocked = false
) => {
  const stored = {
    ...payload,
    userPermissions: { canManage: false, userRole: null },
    canPreview: false,
    canFinalize: false,
  };

  if (includePayouts || resultsLocked) {
    if (!includePayouts) {
      stored.payouts = null;
    }
    return stored;
  }

  return {
    ...stored,
    showPayouts: false,
    payouts: null,
    results: stripResultPrizes(payload.results),
  };
};
